export default "__VITE_ASSET__af4_CxcS__"